import React, { useCallback, useEffect, useState } from 'react';
import { DialogTitle } from '@mui/material';
import { Dialog } from 'components/Dialogs';
import { RESULTS_DISPLAY } from 'pages/DocumentGenerationJobs/constants';
import { useResponse } from 'services/hooks';
import ResultsDisplayModalProps from './ResultsDisplayModal.props';
import BaseJsonView from '../../../../components/JsonView/BaseJsonView';

const ResultsDisplayModal = ({ resultsJsonString, children, ...rest }: ResultsDisplayModalProps) => {
  const [resultsJsonObject, setResultsJsonObject] = useState<object>({});
  const { errorNotification } = useResponse();

  const generateFormattedResults = useCallback(() => {
    try {
      const resultsObject = JSON.parse(resultsJsonString);
      setResultsJsonObject(resultsObject);
    } catch (e) {
      errorNotification(RESULTS_DISPLAY.ERROR_PARSING_RESULTS);
    }
  }, [resultsJsonString, errorNotification]);

  useEffect(() => {
    if (resultsJsonString) {
      generateFormattedResults();
    }
  }, [resultsJsonString, generateFormattedResults]);

  return (
    <Dialog open={rest.open} onClose={() => rest.onClose && rest.onClose({}, 'backdropClick')}>
      <DialogTitle>{RESULTS_DISPLAY.TITLE}</DialogTitle>
      <BaseJsonView jsonData={resultsJsonObject} />
    </Dialog>
  );
};

export default ResultsDisplayModal;
